export default __webpack_public_path__ + "static/media/muscles.1bb5f147.svg";